/**
 * AdminSkeleton — Uniforme skeleton loading-blokken voor admin secties.
 *
 * Voorbeeld:
 *   <AdminSkeleton variant="kpi-grid" count={6} />
 *   <AdminSkeleton variant="table" rows={5} cols={7} />
 *   <AdminSkeleton variant="lines" rows={3} />
 */
import React from "react";

const Line = ({ className = "" }) => (
  <div className={`bg-slate-200/70 rounded-md animate-pulse ${className}`} />
);

export default function AdminSkeleton({
  variant = "lines",
  count = 4,
  rows = 4,
  cols = 6,
  className = "",
  testid = "admin-skeleton",
}) {
  if (variant === "kpi-grid") {
    return (
      <div
        className={`grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 ${className}`}
        data-testid={testid}
      >
        {Array.from({ length: count }).map((_, i) => (
          <div
            key={i}
            className="rounded-xl border border-slate-200 bg-white p-4 shadow-brand-soft"
          >
            <Line className="h-3 w-2/3" />
            <Line className="h-6 w-1/2 mt-3" />
            <Line className="h-3 w-1/3 mt-3" />
          </div>
        ))}
      </div>
    );
  }
  if (variant === "table") {
    return (
      <div
        className={`bg-white border border-slate-200 rounded-2xl overflow-hidden shadow-brand-soft ${className}`}
        data-testid={testid}
      >
        <div className="px-4 py-3 border-b border-slate-200 bg-slate-50 flex gap-3">
          {Array.from({ length: cols }).map((_, i) => (
            <Line key={i} className="h-3 flex-1" />
          ))}
        </div>
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="px-4 py-3 border-b border-slate-100 last:border-b-0 flex gap-3 items-center">
            {Array.from({ length: cols }).map((__, j) => (
              <Line key={j} className={`h-3 flex-1 ${j === 0 ? "max-w-[80px]" : ""}`} />
            ))}
          </div>
        ))}
      </div>
    );
  }
  return (
    <div className={`space-y-3 ${className}`} data-testid={testid}>
      {Array.from({ length: rows }).map((_, i) => (
        <Line key={i} className={`h-4 ${i === rows - 1 ? "w-2/3" : "w-full"}`} />
      ))}
    </div>
  );
}
